import React from 'react';
import styles from './Hero.module.css';
import heroBgImage from '../../assets/images/storefrontbackground.png';

const Hero = () => {
  return (
    <section 
      className={styles.hero}
      style={{ backgroundImage: `url(${heroBgImage})` }}
    >
      <div className={styles.heroOverlay}></div> {/* For darkening the background */}
      <div className={`${styles.container} ${styles.heroContent}`}>
        <img src="/images/mainlogo.png" alt="Pizza Fresca Main Logo" className={styles.heroLogo} /> 
        <h1 className={styles.heroTitle}>Elite Cleaners</h1>
        <p className={styles.heroSubtitle}>Located in the heart of Downtown, Richmond</p>
        {/* Optional: Add a call-to-action button here */}
        {/* <a href="#order" className={styles.heroButton}>Order Now</a> */}
      </div>
    </section>
  );
};

export default Hero;
